import "./Contact.css";
import {
  FaUniversity,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
  FaClock
} from "react-icons/fa";

function Contact() {
  return (
    <div className="contact-page">
      <img src="/images/clgslogo.png" alt="College Logo" />

      <h1 className="main-title">Masters Degree & PG College</h1>

      <section className="info-block">
        <h2><FaUniversity /> College Information</h2>
        <p>
          Masters Degree & PG College is one of the well established institutions 
          offering Undergraduate and Postgraduate programs. The college focuses 
          on academic excellence, discipline and overall student development.
        </p>
      </section>

      <section className="info-block">
        <h2><FaMapMarkerAlt /> Address</h2>
        <p>
          Shanthi Nagar, Sangareddy<br/>
          Telangana – 500001<br/>
          India
        </p>
      </section>

      <section className="info-block">
        <h2><FaPhoneAlt /> Contact Numbers</h2>
        <p> Principal: +91 9705460212</p>
        <p> Vice Principal: 9908238668</p>
        <p>Office: 9063020212</p>
      </section>

      <section className="info-block">
        <h2><FaEnvelope /> Official Email</h2>
        <p>
  <a href="mailto:principal@mastersdegreepgcollege.in">
    principal@mastersdegreepgcollege.in
  </a>
</p>
      </section>

      <section className="info-block">
        <h2><FaGlobe /> Website</h2>
        <p>
  <a 
    href="https://mastersdegreepgcollege.in" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    https://mastersdegreepgcollege.in
  </a>
</p>
      </section>

      <section className="info-block">
        <h2><FaClock /> Working Hours</h2>
        <p>Monday – Saturday: 9:00 AM – 5:00 PM</p>
        <p>Sunday: Holiday</p>
      </section>
      <section className="info-block">
  <h2><FaMapMarkerAlt /> Our Location on Map</h2>

  <div className="map-container">
    <iframe
      title="college-location"
      src="https://www.google.com/maps?q=Masters%20Degree%20%26%20PG%20College&output=embed"
      width="100%"
      height="350"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
    ></iframe>
  </div>

</section>
<section className="info-block">
  <h2>📍 Location</h2>
  <p>Sangareddy, Telangana, India</p>

  <a
    href="https://maps.app.goo.gl/wMeegPmwuUaoEUj7A"
    target="_blank"
    rel="noopener noreferrer"
    className="map-link"
  >
    Open in Google Maps
  </a>
</section>



    </div>
  );
}

export default Contact;
